import Topic from "./topic";
import DataList from "./DataList";
import DropdownSort from "./DropdownSort";
import ErrorMessage from "./ErrorMessage";
import GameZone from "./GameZone";
import Panel from "./Panel";
import PanelTitle from "./PanelTitle";
import TopicScroll from "./TopicScroll";
import bbcode from "./Wysibb";
import OrderScroll from "./OrderScroll";
import RecordScroll from "./RecordScroll";
import TicketScroll from "./TicketScroll";
import DraftScroll from "./DraftScroll";
import Calendar from "./calendar";
import DataSelect from "./DataSelect";
import GameScroll from "./GameScroll";
import YunScroll from "./YunScroll";
import ServiceItem from "./ServiceItem";

const components = [
  ...Topic,
  DataList,
  DropdownSort,
  ErrorMessage,
  GameZone,
  Panel,
  PanelTitle,
  TopicScroll,
  bbcode,
  OrderScroll,
  RecordScroll,
  TicketScroll,
  DraftScroll,
  Calendar,
  DataSelect,
  GameScroll,
  YunScroll,
  ServiceItem,
];
const install = (Vue, opts = {}) => {
  if (install.installed) return;
  for (let cop of components) {
    if (!cop.name) continue;
    Vue.component(cop.name, cop);
  }
};
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
};
